// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tKwQW","title":"styles_title__y32+H"};